import { DivestitureDiagnosticUtility } from '@pwc/pwc-deals-web-common';
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Icon } from '@pwc/pwc-deals-ui';

import './WelcomeBoxDealComplexity.scss';
import ComplexityScaleWrapper from '../../../../../common/components/DivestitureDiagnosticResults/ComplexityScaleWrapper/ComplexityScaleWrapper';
import { getDivestitureDiagnosticResults } from '../../../../divestitureDiagnostic/divestitureDiagnosticSlice';
import { formatResultsRoute } from '../../../../divestitureDiagnostic/routes';
import EnableForProjectState from '../../../../security/EnableForProjectState';

const WelcomeBoxDealComplexity = ({ projectId }) => {
  const { overallDealComplexity } = useSelector(
    getDivestitureDiagnosticResults
  );

  const scoreLabel = DivestitureDiagnosticUtility.calculateScoreText(
    (overallDealComplexity || {}).value
  );

  return (
    <EnableForProjectState projectId={projectId}>
      {({ isProjectDisabled }) => (
        <div className="welcomebox-deal-complexity-container">
          <div className="overall-deal-complexity-view-wrapper">
            <h2>{`Deal Complexity: ${scoreLabel}`}</h2>
            <ComplexityScaleWrapper
              initial={
                overallDealComplexity && overallDealComplexity.initialValue
              }
              modified={overallDealComplexity && overallDealComplexity.value}
              backgroundColor="background-primary"
              highLow
              showTooltip
            />
          </div>
          {!isProjectDisabled && (
            <div className="view-diagnostic-button">
              <Link to={formatResultsRoute(projectId)}>
                <Icon
                  name="arrow-right"
                  width={30}
                  fill="#ffff"
                  className="outline icon-orange"
                />
              </Link>
            </div>
          )}
        </div>
      )}
    </EnableForProjectState>
  );
};

export default WelcomeBoxDealComplexity;
